import Coverage from '../components/coverageComponent/Coverage';

export interface Modal {
	show: boolean;
	id: string;
	track?: boolean;
	trackToken?: string;
	errorType?: string;
	productName?: string;
	stepName?: string;
	trackMsg?: string;
	content?: string;
	btnType?: 'tel' | 'button' | 'mailto' | 'link';
	btnStyle?: string;
	btnLabel?: string;
	btnSecondStyle?: string;
	btnSecondLabel?: string;
	btnInlineLabel?: string;
	btnInlineAction?: string | Function;
	btnInlineStyle?: string;
	btnInlineIcon?: string;
	title?: string;
	redirect?: string;
	redirectOnClose?: boolean;
}

export const enum PlusCustomerType {
	PK0 = 'pk0',
	PK1 = 'pk1',
	PK2 = 'pk2',
	PK3 = 'pk3',
}

export const plusCustomerDiscount: Map<PlusCustomerType, number> = new Map([
	[PlusCustomerType.PK0, 0],
	[PlusCustomerType.PK1, 0.05],
	[PlusCustomerType.PK2, 0.1],
	[PlusCustomerType.PK3, 0.15],
]);

export const PlusCustomerArray = [
	PlusCustomerType.PK0,
	PlusCustomerType.PK1,
	PlusCustomerType.PK2,
	PlusCustomerType.PK3,
];

export interface UpSaleProduct {
	productNameDisplay: string;
	productNameDisplayMobile: string;
	productName: string;
	validUpSaleProduct: boolean;
	basePrice: number;
	yearlyBasePrice: number;
	pk0: PkPrice;
	pk1: PkPrice;
	pk2: PkPrice;
	pk3: PkPrice;
	currentLevel: PlusCustomerType;
	originalLevel: PlusCustomerType;
	monthly: boolean;
	packageName: string;
	upSaleCampaignDiscount: number;
}

export interface UpSaleCampaignData {
	calculatorCommonModel: CalculatorCommonModel;
	upSaleProducts: UpSaleProduct[];
	hideUpsalePk3: boolean;
}

export interface CalculatorData {
	cms: any;
	model: any;
}
export interface CustomerCalculation {
	useLogout: boolean;
	hasCustomerData: boolean;
	customerFetched: boolean;
	agreementsFetched: boolean;
	customer: {
		contact_information: any;
		personInfo: any;
	};
}
export interface CalculatorCommonModel {
	personInfo: {
		customerAge?;
		address?;
		zipCode?;
		zipName?;
		streetName?;
		houseNr?;
		floorNr?;
		doorNr?;
		kvhxValue?;
		familyMemberCount?;
		familyMemberCountId?;
		almbrandCustomer?;
		existingAlmBrandProducts: Array<string>;
	};
	additionalInfo: {
		validNow?;
		validFromDate?;
	};
	contact_information: {
		name?;
		phone?;
		email?;
		customerNo?;
		cpr?;
	};
	showExistingAlmBrandProducts: boolean;
}

export interface PackageCalculation {
	id: number;
	name?: string;
	specialDiscount?: number;
	statutoryFee?: number;
	basePrice?: number;
	totalPrice?: number;
	totalPriceDisplay?: string;
	yearlyBasePrice?: number;
	yearlyStatutoryFee?: number;
	yearlyPriceTotal?: number;
	yearlyPriceTotalDisplay?: string;
	currentPlusCostumerLevel?: string;
	pkPrices?: PkPrices;

	// accident child and family
	summedBasePrice?: number;
	summedStatutoryFee?: number; // not returned by api
	summedTotalPrice?: number;

	summedYearlyBasePrice?: number;
	summedYearlyStatutoryFee?: number; // not returned by api
	summedYearlyPriceTotal?: number;

	// family
	coverages: Array<Coverage>;
	expandedCoverages: Array<string>;
}

export interface PkPrice {
	price: number;
	display: string;
}

export interface PkPrices {
	monthly: {
		pk0?: PkPrice; // plusCustomer 0 price
		pk1?: PkPrice; // plusCustomer .95 price
		pk2?: PkPrice; // plusCustomer .90 price
		pk3?: PkPrice; // plusCustomer .85 price
	};
	yearly: {
		pk0?: PkPrice; // plusCustomer 0 price
		pk1?: PkPrice; // plusCustomer .95 price
		pk2?: PkPrice; // plusCustomer .90 price
		pk3?: PkPrice; // plusCustomer .85 price
	};
}

export interface KeyValue {
	key: string;
	value: number;
}
export interface PackageConfig {
	id: number;
	name: string;
	description: string;
	includedCoverageIds: number[]; // KLK strings in accident
	includedCoveragesExpandedIds: number[]; // KLK strings in accident
	calculateRisksCar: number[];
	sums: { covId: string; sum: number }[];
	minAge: number;
	maxAge: number;
	coverages: Coverage[]; // accident
	expandedCoverages: string[];
}

/*** EPI *****/

export interface EpiContentState {
	modelLoaded: boolean;
	model: any;
	modelLanguage: string;
}
